import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "menu-select",
  style: {
    "width": "100%",
    "height": "100%"
  }
};
import { tree } from '@/api/system/menu';
import { MENU_STYLE } from '@/constant/system/code';
import { ElSelect } from 'element-plus';
import 'element-plus/es/components/select/style/css'


import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'MenuSelect',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const prop = __props;
    const emit = __emit;
    const selectRef = ref();
    const data = ref([]);
    const defaultProps = {
      children: 'children',
      label: 'menuName'
    };
    /**
     * 将树结构转化为选项
     */
    const selectOption = computed(() => {
      const option = [];
      function getChildren(data) {
        data.forEach(item => {
          option.push({
            label: item.menuName,
            value: item.id
          });
          if (item.children) {
            getChildren(item.children);
          }
        });
      }
      getChildren(data.value);
      return option;
    });
    const selectValue = computed({
      get() {
        if (selectOption.value.length === 0) {
          return '';
        }
        return prop.modelValue;
      },
      set(newVal) {
        emit('update:modelValue', newVal);
      }
    });
    tree().then(result => {
      data.value = filterDirectoryNode(result.data);
    });
    /**
     * 过滤目录节点
     * @param data 全部节点
     */
    function filterDirectoryNode(data) {
      const res = data.filter(item => item.menuStyle === MENU_STYLE.CATALOG);
      res.forEach(item => {
        if (item.children) {
          item.children = filterDirectoryNode(item.children);
        }
      });
      return res;
    }
    /**
     * 节点点击
     * @param e 事件
     */
    function nodeClick(e) {
      selectValue.value = e.id;
      selectRef.value?.blur();
      // selectRef.value?.handleClose()
    }
    return (_ctx, _cache) => {
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_option = _resolveComponent("el-option");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElSelect), {
        modelValue: _unref(selectValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(selectValue) ? selectValue.value = $event : null),
        placeholder: "请选择目录",
        style: {
          "width": "100%",
          "height": "100%"
        },
        ref_key: "selectRef",
        ref: selectRef
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          style: {
            "height": "auto",
            "background": "white",
            "padding": "0"
          },
          value: "tree-select-option",
          label: "tree-select-option",
          disabled: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tree, {
            data: _unref(data),
            props: defaultProps,
            onNodeClick: nodeClick
          }, null, 8, ["data"])]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectOption), (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"])), [[_vShow, false]]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});